// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__dYpH_","content":"styles_content__1cTzq","checkbox":"styles_checkbox__1YBgm","checkboxLabel":"styles_checkboxLabel__TA6Rp"};